function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5968 6C16.6192 6 15.0423 6.99339 14.0677 7.8271L14.0334 7.85661L13.4784 8.46L14.7035 10.4734L15.6103 9.56419C16.5592 8.7629 17.6184 8.32258 18.5968 8.32258C20.571 8.32258 22.1774 9.88548 22.1774 11.8065C22.1774 13.7274 20.571 15.2903 18.5968 15.2903C15.5968 15.2903 13.5577 11.325 13.5374 11.2848C13.4194 11.0463 10.8335 6 6.40323 6C3.14823 6 0.5 8.60468 0.5 11.8065C0.5 15.0082 3.14823 17.6129 6.40323 17.6129C7.99758 17.6129 9.56677 16.9785 10.9415 15.7781L10.971 15.7519L11.5216 15.1529L10.296 13.1395L9.38484 14.0531C8.43548 14.8742 7.43194 15.2903 6.40323 15.2903C4.42903 15.2903 2.82258 13.7274 2.82258 11.8065C2.82258 9.88548 4.42903 8.32258 6.40323 8.32258C9.40323 8.32258 11.4423 12.2879 11.4626 12.3281C11.5806 12.5666 14.1665 17.6129 18.5968 17.6129C21.8518 17.6129 24.5 15.0082 24.5 11.8065C24.5 8.60468 21.8518 6 18.5968 6Z"
});
function SvgCoFarmButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "white",
    opacity: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoFarmButtonIcon);
export default __webpack_public_path__ + "static/media/coFarmButtonIcon.b5fc5ff353a45d4029049f01e1a78d0e.svg";
export { ForwardRef as ReactComponent };